import { Command } from "./ui/command";
import { Drawer, DrawerContent, DrawerDescription, DrawerTitle } from "./ui/drawer";
import { useVisualViewportHeight } from "../hooks/use-mobile-combobox";
import { cn } from "../lib/utils";

export function MobileCommandSheet({
  open,
  onOpenChange,
  title,
  input,
  children,
  commandClassName,
  commandProps,
}) {
  const viewportHeight = useVisualViewportHeight(open);
  const sheetHeight = viewportHeight
    ? `min(90dvh, ${Math.max(viewportHeight - 12, 320)}px)`
    : "90dvh";

  return (
    <Drawer open={open} onOpenChange={onOpenChange} shouldScaleBackground={false}>
      <DrawerContent
        className="z-[70] h-[90dvh] max-h-[90dvh] px-0"
        style={{
          height: sheetHeight,
          maxHeight: sheetHeight,
          paddingBottom: "max(env(safe-area-inset-bottom), 12px)",
        }}
      >
        <Command
          className={cn("min-h-0 flex-1 rounded-none bg-background", commandClassName)}
          {...commandProps}
        >
          <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
            <div className="shrink-0 border-b px-4 pb-3 pt-4">
              <DrawerTitle className="mb-2 text-sm font-medium leading-5 tracking-normal">
                {title}
              </DrawerTitle>
              <DrawerDescription className="sr-only">
                Busque e selecione uma opção.
              </DrawerDescription>
              {input}
            </div>
            <div
              className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-2 py-2"
              style={{
                WebkitOverflowScrolling: "touch",
                touchAction: "pan-y",
              }}
            >
              {children}
            </div>
          </div>
        </Command>
      </DrawerContent>
    </Drawer>
  );
}
